import { IdentityTypeProps } from "_interfaces/phoneBooking";

interface Props {
  identityType?: IdentityTypeProps | "";
  name?: string;
  email?: string;
  phoneNumber?: string;
  nationalIdIdNumber?: string;
  refugeeDocumentNumber?: string;
  passportNumber?: string;
}

const defaultData: Props = {
  identityType: "",
  name: "",
  email: "",
  phoneNumber: "",
  nationalIdIdNumber: "",
  refugeeDocumentNumber: "",
  passportNumber: "",
};

export class CreateAccountModel {
  identityType?: IdentityTypeProps | "";
  name?: string;
  email?: string;
  phoneNumber?: string;
  nationalIdIdNumber?: string;
  refugeeDocumentNumber?: string;
  passportNumber?: string;

  constructor(data: Props = defaultData) {
    this.identityType = data.identityType || "";
    this.name = data.name || "";
    this.email = data.email || "";
    this.phoneNumber = data.phoneNumber || "";
    this.nationalIdIdNumber = data.nationalIdIdNumber || "";
    this.refugeeDocumentNumber = data.refugeeDocumentNumber || "";
    this.passportNumber = data.passportNumber || "";
  }
}
